import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=626519b4&scoped=true&"
import script from "./SchoolList.vue?vue&type=script&lang=js&"
export * from "./SchoolList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=626519b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626519b4",
  null
  
)

export default component.exports